

const populateLinkedBlocksWithDishes = (blocks=[], productsIndex={}, menu={}) => {
  const subMenus = menu.subMenus || []
  return blocks.map((block) => {
    if (block.linked && block.type.includes('dish')) {
      let dish = productsIndex[block.linked_id] || {}
      return(Object.assign({}, block, { content: dish }))
    } else if (block.linked && block.type.includes('text-list')) {
      let subMenu = subMenus.find(subMenu => subMenu.id === block.linked_category_id)
      return(Object.assign({}, block, { content: subMenu }))
    } else {
      return(block)
    }
  })
}

export default populateLinkedBlocksWithDishes
